// extracted by mini-css-extract-plugin
export default {"container":"AdminLayout_container__VTCxm","main":"AdminLayout_main__PqQG5"};